import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { NavScrollComponent } from '../navbar/nav-scroll';

@Component({ className: 'js-has-children' })
export class HeaderComponent {
	private navLevel: any;

	constructor(private element: HTMLElement) {
		this.navLevel = element.getAttribute('data-nav-level');

		this.addClickListener();
	}

	addClickListener() {
		this.element.addEventListener('click', () => {
			const id = this.element.dataset.id;

			const shownCols = document.querySelectorAll('.js-nav-col:not(.hidden)');
			shownCols.forEach(col => {
				const colNavLevel = col.getAttribute('data-nav-level');
				if (+(colNavLevel ?? '1') >= +this.navLevel) {
					col.classList.add('hidden');
				}
			});

			const shownCrumbs = document.querySelectorAll('.js-nav-breadcrumb-item:not(.hidden)');
			shownCrumbs.forEach(crumb => {
				const crumbNavLevel = crumb.getAttribute('data-nav-level');
				if (+(crumbNavLevel ?? '1') >= +this.navLevel) {
					crumb.classList.add('hidden');
				}
			});

			const crumbToShow = document.querySelector('.js-nav-breadcrumb-item[data-id="' + id + '"]');
			crumbToShow?.classList.remove('hidden');

			const childCol = document.querySelector('[data-parent="' + id + '"]');
			childCol?.classList.remove('hidden');
			childCol?.classList.add('unhiding');
			setTimeout(function () { childCol?.classList.remove('unhiding'); }, 0);
			document.querySelectorAll('.js-collapse-item').forEach(item => {
				if (+(item.getAttribute('data-nav-level') ?? '1') >= +this.navLevel) {
					item.classList.remove('is-active');
				}
			});
			this.element.classList.add('is-active');
			const fullWidth = document.body.clientWidth;
			const gutterPx = getComputedStyle(document.querySelector('.js-navbar-sizer')).getPropertyValue('padding-left');
			const gutter = +(gutterPx?.replace('px', '') ?? '0');
			const containerWidth = document.querySelector('.js-navbar-sizer').clientWidth - 2 * gutter;
			const scrollWidth = fullWidth >= 992 ? containerWidth / 3 : containerWidth;
			const scrollLevel = fullWidth >= 992 ? (this.navLevel > 2 ? this.navLevel - 3 : 0) : (this.navLevel > 1 ? this.navLevel - 1 : 0);
			document.querySelector('.js-nav-row').setAttribute('style', `transform: translateX(calc(-1 * ${scrollLevel} * ${scrollWidth}px))`);
			document.querySelector('.js-nav-row').setAttribute('data-active-level', this.navLevel);
		});
	}
}
